import { useState } from "react";
import api from "@/lib/api";
import SEO from "@/components/SEO";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { Label } from "@/components/ui/label";

export default function Contact() {
  const [f, setF] = useState({ profile: "vendeur", name: "", email: "", phone: "", city: "", message: "" });
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/contact", f);
      toast.success("Message envoyé. Nous vous répondons rapidement.");
      setF({ profile: "vendeur", name: "", email: "", phone: "", city: "", message: "" });
    } catch { toast.error("Erreur d'envoi, réessayez."); }
    finally { setBusy(false); }
  };

  return (
    <>
      <SEO title="Nous contacter — venteaterme.fr" description="Une question sur la vente à terme ? Contactez notre équipe d'experts. Réponse sous 24 h ouvrées." />
      <section className="pt-24 pb-12 bg-navy text-cream">
        <div className="max-w-4xl mx-auto px-6 md:px-10">
          <div className="text-xs uppercase tracking-[0.3em] text-accent-brand font-bold mb-4">Contact</div>
          <h1 className="font-serif text-4xl md:text-6xl leading-tight">Parlons de votre projet.</h1>
          <p className="text-cream/80 mt-6 max-w-2xl">Vendeur ou acheteur, un expert de la vente à terme vous répond sous 24 h ouvrées.</p>
        </div>
      </section>

      <section className="py-16">
        <div className="max-w-3xl mx-auto px-6">
          <form onSubmit={submit} data-testid="contact-form" className="bg-white border border-navy/10 p-8 md:p-10 space-y-6">
            <div>
              <Label className="text-[10px] uppercase tracking-wider text-navy/60 font-bold">Vous êtes</Label>
              <RadioGroup value={f.profile} onValueChange={(v) => setF({ ...f, profile: v })} className="grid grid-cols-3 gap-3 mt-3">
                {[["vendeur", "Vendeur"], ["acheteur", "Acheteur"], ["autre", "Autre"]].map(([v, lb]) => (
                  <label key={v} data-testid={`contact-profile-${v}`}
                    className={`cursor-pointer border p-3 flex items-center gap-2 text-sm ${f.profile === v ? "border-accent-brand bg-accent-brand/5" : "border-navy/15"}`}>
                    <RadioGroupItem value={v} id={`p-${v}`} /><span>{lb}</span>
                  </label>
                ))}
              </RadioGroup>
            </div>
            <div className="grid md:grid-cols-2 gap-4">
              <div>
                <Label className="text-[10px] uppercase tracking-wider text-navy/60 font-bold">Nom</Label>
                <Input data-testid="contact-name" required value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className="mt-2 border-navy/20" />
              </div>
              <div>
                <Label className="text-[10px] uppercase tracking-wider text-navy/60 font-bold">Ville</Label>
                <Input data-testid="contact-city" value={f.city} onChange={(e) => setF({ ...f, city: e.target.value })} className="mt-2 border-navy/20" />
              </div>
              <div>
                <Label className="text-[10px] uppercase tracking-wider text-navy/60 font-bold">Email</Label>
                <Input data-testid="contact-email" type="email" required value={f.email} onChange={(e) => setF({ ...f, email: e.target.value })} className="mt-2 border-navy/20" />
              </div>
              <div>
                <Label className="text-[10px] uppercase tracking-wider text-navy/60 font-bold">Téléphone</Label>
                <Input data-testid="contact-phone" value={f.phone} onChange={(e) => setF({ ...f, phone: e.target.value })} className="mt-2 border-navy/20" />
              </div>
            </div>
            <div>
              <Label className="text-[10px] uppercase tracking-wider text-navy/60 font-bold">Votre message</Label>
              <Textarea data-testid="contact-message" required rows={5} value={f.message} onChange={(e) => setF({ ...f, message: e.target.value })} className="mt-2 border-navy/20" />
            </div>
            <button disabled={busy} data-testid="contact-submit" className="w-full bg-accent-brand text-white font-bold py-4 tracking-wide hover:bg-[#B08D22] transition-colors disabled:opacity-60">
              {busy ? "Envoi..." : "Envoyer mon message"}
            </button>
            <p className="text-xs text-navy/55 leading-relaxed border-t border-navy/10 pt-4">
              <strong className="text-navy">RGPD.</strong> Les données collectées via ce formulaire sont utilisées exclusivement pour traiter votre demande et conservées 24 mois. Conformément au règlement européen 2016/679 (RGPD) et à la loi Informatique et Libertés, vous disposez d'un droit d'accès, de rectification, d'effacement et d'opposition en écrivant à contact@venteaterme.fr.
            </p>
          </form>
        </div>
      </section>
    </>
  );
}
